import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';

import { useAlergoide } from '../hooks/useAlergoide';
import { useForm, useFormValidation } from '../../../../../hooks';

import { CheckboxInput, DiasSemanaSelector, LightButton, MultiFormAplicacionGotas, MultiFormAplicacionML, MultiFormFrascosAlxoid, MultiFormFrascosOraltek, NumberInput, PrimaryButton, RadiobuttonGroup, ReactSelectSingleKeyInput, SwitchInput } from "../../../../../components";

import styles from './../Alergoide.module.css';

export const AlergoideUpdate = ({ alergoideAux }) => {

    const { updateAlergoideMutation: { mutate: updateAlergoide, isPending } } = useAlergoide();

    const [resetFields, setResetFields] = useState(true);

    const [dataStatus, setDataStatus] = useState(false);

    const [rangoMinimoUnidadMantenimientoOraltekReset, setRangoMinimoUnidadMantenimientoOraltekReset] = useState(true);

    const { alxoid, sitioAplicacionAlxoid, ladoAplicacionAlxoid, reaccionAlxoid, sitioAplicacionBrazoAlxoid, sitioAplicacionAbdomenAlxoid, sitioAplicacionOtroAlxoid, ladoAplicacionDerechoAlxoid, ladoAplicacionIzquierdoAlxoid, alergenoDermasAlxoid, alergenoDermasBlomiaAlxoid, alergenoPhleumPratenseAlxoid, alergenoLoliumAlxoid, alergenoCynodonAlxoid, alergeno6GramineasAlxoid, alergeno6GramineasCynodonAlxoid, alergeno4CerealesAlxoid, alergenoChenopodiumSalsolaAlxoid, alergenoAmbrosiaArtemisaAlxoid, alergenoFraxinusExcelsiorAlxoid, alergenoQuercusRoburAlxoid, alergenoCupressusAlxoid, alergenoPerroAlxoid, alergenoGatoAlxoid, alergenoDermas6GramineasAlxoid, alergenoDermas6GramineasCynodonAlxoid, alergenoDermas6GramineasFraxinusAlxoid, alergenoDermasFraxinusQuercusAlxoid, alergeno6GramineasCynodonQuercusFraxinusAlxoid, induccionAlxoid, frascosInduccionAlxoid, frecuenciaInduccionAlxoid, diasFrecuenciaInduccionAlxoid, diasSemanaInduccionAlxoid, rangoMinimoInduccionAlxoid, rangoMinimoUnidadInduccionAlxoid, rangoMaximoInduccionAlxoid, rangoMaximoUnidadInduccionAlxoid, caducidadInduccionAlxoid, caducidadUnidadInduccionAlxoid, aplicacionesDataInduccionAlxoid, mantenimientoAlxoid, frascosMantenimientoAlxoid, frecuenciaMantenimientoAlxoid, diasFrecuenciaMantenimientoAlxoid, diasSemanaMantenimientoAlxoid, rangoMinimoMantenimientoAlxoid, rangoMinimoUnidadMantenimientoAlxoid, rangoMaximoMantenimientoAlxoid, rangoMaximoUnidadMantenimientoAlxoid, caducidadMantenimientoAlxoid, caducidadUnidadMantenimientoAlxoid, aplicacionesDataMantenimientoAlxoid, oraltek, reaccionOraltek, alergenoDermasOraltek, alergenoCynodonOraltek, alergeno6GramineasOraltek, alergeno6GramineasCynodonOraltek, alergenoChenopodiumSalsolaOraltek, alergenoAmbrosiaArtemisaOraltek, alergenoFraxinusExcelsiorOraltek, alergenoQuercusRoburOraltek, alergenoCupresaceasOraltek, alergenoProsopisOraltek, alergenoDermas6GramineasOraltek, mantenimientoOraltek, frascosMantenimientoOraltek, frecuenciaMantenimientoOraltek, diasFrecuenciaMantenimientoOraltek, diasSemanaMantenimientoOraltek, rangoMinimoMantenimientoOraltek, rangoMinimoUnidadMantenimientoOraltek, rangoMaximoMantenimientoOraltek, rangoMaximoUnidadMantenimientoOraltek, caducidadMantenimientoOraltek, caducidadUnidadMantenimientoOraltek, aplicacionesDataMantenimientoOraltek, onInputChange, onMultipleInputChange, onResetForm } = useForm({ alxoid: alergoideAux.alxoid.inmunoterapias.alxoid, sitioAplicacionAlxoid: alergoideAux.alxoid.inmunoterapias.sitioAplicacion, ladoAplicacionAlxoid: alergoideAux.alxoid.inmunoterapias.ladoAplicacion, reaccionAlxoid: alergoideAux.alxoid.inmunoterapias.reaccion, sitioAplicacionBrazoAlxoid: alergoideAux.alxoid.inmunoterapias.sitioAplicacionBrazo, sitioAplicacionAbdomenAlxoid: alergoideAux.alxoid.inmunoterapias.sitioAplicacionAbdomen, sitioAplicacionOtroAlxoid: alergoideAux.alxoid.inmunoterapias.sitioAplicacionOtro, ladoAplicacionDerechoAlxoid: alergoideAux.alxoid.inmunoterapias.ladoAplicacionDerecho, ladoAplicacionIzquierdoAlxoid: alergoideAux.alxoid.inmunoterapias.ladoAplicacionIzquierdo, alergenoDermasAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoDermas, alergenoDermasBlomiaAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoDermasBlomia, alergenoPhleumPratenseAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoPhleumPratense, alergenoLoliumAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoLolium, alergenoCynodonAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoCynodon, alergeno6GramineasAlxoid: alergoideAux.alxoid.inmunoterapias.alergeno6Gramineas, alergeno6GramineasCynodonAlxoid: alergoideAux.alxoid.inmunoterapias.alergeno6GramineasCynodon, alergeno4CerealesAlxoid: alergoideAux.alxoid.inmunoterapias.alergeno4Cereales, alergenoChenopodiumSalsolaAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoChenopodiumSalsola, alergenoAmbrosiaArtemisaAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoAmbrosiaArtemisa, alergenoFraxinusExcelsiorAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoFraxinusExcelsior, alergenoQuercusRoburAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoQuercusRobur, alergenoCupressusAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoCupressus, alergenoPerroAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoPerro, alergenoGatoAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoGato, alergenoDermas6GramineasAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoDermas6Gramineas, alergenoDermas6GramineasCynodonAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoDermas6GramineasCynodon, alergenoDermas6GramineasFraxinusAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoDermas6GramineasFraxinus, alergenoDermasFraxinusQuercusAlxoid: alergoideAux.alxoid.inmunoterapias.alergenoDermasFraxinusQuercus, alergeno6GramineasCynodonQuercusFraxinusAlxoid: alergoideAux.alxoid.inmunoterapias.alergeno6GramineasCynodonQuercusFraxinus, induccionAlxoid: alergoideAux.alxoid.induccion.isActive, frascosInduccionAlxoid: (typeof alergoideAux.alxoid.induccion.frascos !== 'undefined') ? alergoideAux.alxoid.induccion.frascos : [{id: moment().unix(), frasco: 'A', volumenAlergeno: '', volumenTotal: ''}], frecuenciaInduccionAlxoid: String(alergoideAux.alxoid.induccion.frecuencia), diasFrecuenciaInduccionAlxoid: alergoideAux.alxoid.induccion.diasFrecuencia, diasSemanaInduccionAlxoid: (typeof alergoideAux.alxoid.induccion.diasSemana !== 'undefined') ? alergoideAux.alxoid.induccion.diasSemana : {lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado:false, domingo: false}, rangoMinimoInduccionAlxoid: alergoideAux.alxoid.induccion.rangoMinimo, rangoMinimoUnidadInduccionAlxoid: String(alergoideAux.alxoid.induccion.rangoMinimoUnidad), rangoMaximoInduccionAlxoid: alergoideAux.alxoid.induccion.rangoMaximo, rangoMaximoUnidadInduccionAlxoid: String(alergoideAux.alxoid.induccion.rangoMaximoUnidad), caducidadInduccionAlxoid: alergoideAux.alxoid.induccion.caducidad, caducidadUnidadInduccionAlxoid: String(alergoideAux.alxoid.induccion.caducidadUnidad), aplicacionesDataInduccionAlxoid: (typeof alergoideAux.alxoid.induccion.aplicacionesData !== 'undefined') ? alergoideAux.alxoid.induccion.aplicacionesData : [{id: moment().unix(), dosis: '', repeticiones: ''}], mantenimientoAlxoid: alergoideAux.alxoid.mantenimiento.isActive, frascosMantenimientoAlxoid: (typeof alergoideAux.alxoid.mantenimiento.frascos !== 'undefined') ? alergoideAux.alxoid.mantenimiento.frascos : [{id: moment().unix(), frasco: 'B', volumenTotal: ''}], frecuenciaMantenimientoAlxoid: String(alergoideAux.alxoid.mantenimiento.frecuencia), diasFrecuenciaMantenimientoAlxoid: alergoideAux.alxoid.mantenimiento.diasFrecuencia, diasSemanaMantenimientoAlxoid: (typeof alergoideAux.alxoid.mantenimiento.diasSemana !== 'undefined') ? alergoideAux.alxoid.mantenimiento.diasSemana : {lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado:false, domingo: false}, rangoMinimoMantenimientoAlxoid: alergoideAux.alxoid.mantenimiento.rangoMinimo, rangoMinimoUnidadMantenimientoAlxoid: String(alergoideAux.alxoid.mantenimiento.rangoMinimoUnidad), rangoMaximoMantenimientoAlxoid: alergoideAux.alxoid.mantenimiento.rangoMaximo, rangoMaximoUnidadMantenimientoAlxoid: String(alergoideAux.alxoid.mantenimiento.rangoMaximoUnidad), caducidadMantenimientoAlxoid: alergoideAux.alxoid.mantenimiento.caducidad, caducidadUnidadMantenimientoAlxoid: String(alergoideAux.alxoid.mantenimiento.caducidadUnidad), aplicacionesDataMantenimientoAlxoid: (typeof alergoideAux.alxoid.mantenimiento.aplicacionesData !== 'undefined') ? alergoideAux.alxoid.mantenimiento.aplicacionesData : [{id: moment().unix(), dosis: '', repeticiones: ''}], oraltek: alergoideAux.oraltek.inmunoterapias.oraltek, reaccionOraltek: alergoideAux.oraltek.inmunoterapias.reaccion, alergenoDermasOraltek: alergoideAux.oraltek.inmunoterapias.alergenoDermas, alergenoCynodonOraltek: alergoideAux.oraltek.inmunoterapias.alergenoCynodon, alergeno6GramineasOraltek: alergoideAux.oraltek.inmunoterapias.alergeno6Gramineas, alergeno6GramineasCynodonOraltek: alergoideAux.oraltek.inmunoterapias.alergeno6GramineasCynodon, alergenoChenopodiumSalsolaOraltek: alergoideAux.oraltek.inmunoterapias.alergenoChenopodiumSalsola, alergenoAmbrosiaArtemisaOraltek: alergoideAux.oraltek.inmunoterapias.alergenoAmbrosiaArtemisa, alergenoFraxinusExcelsiorOraltek: alergoideAux.oraltek.inmunoterapias.alergenoFraxinusExcelsior, alergenoQuercusRoburOraltek: alergoideAux.oraltek.inmunoterapias.alergenoQuercusRobur, alergenoCupresaceasOraltek: alergoideAux.oraltek.inmunoterapias.alergenoCupresaceas, alergenoProsopisOraltek: alergoideAux.oraltek.inmunoterapias.alergenoProsopis, alergenoDermas6GramineasOraltek: alergoideAux.oraltek.inmunoterapias.alergenoDermas6Gramineas, mantenimientoOraltek: alergoideAux.oraltek.mantenimiento.isActive, frascosMantenimientoOraltek: (typeof alergoideAux.oraltek.mantenimiento.frascos !== 'undefined') ? alergoideAux.oraltek.mantenimiento.frascos : [{id: moment().unix(), frasco: '1', volumenAlergeno: '', volumenTotal: '6.0'}], frecuenciaMantenimientoOraltek: String(alergoideAux.oraltek.mantenimiento.frecuencia), diasFrecuenciaMantenimientoOraltek: alergoideAux.oraltek.mantenimiento.diasFrecuencia, diasSemanaMantenimientoOraltek: (typeof alergoideAux.oraltek.mantenimiento.diasSemana !== 'undefined') ? alergoideAux.oraltek.mantenimiento.diasSemana : {lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado:false, domingo: false}, rangoMinimoMantenimientoOraltek: alergoideAux.oraltek.mantenimiento.rangoMinimo, rangoMinimoUnidadMantenimientoOraltek: String(alergoideAux.oraltek.mantenimiento.rangoMinimoUnidad), rangoMaximoMantenimientoOraltek: alergoideAux.oraltek.mantenimiento.rangoMaximo, rangoMaximoUnidadMantenimientoOraltek: String(alergoideAux.oraltek.mantenimiento.rangoMaximoUnidad), caducidadMantenimientoOraltek: alergoideAux.oraltek.mantenimiento.caducidad, caducidadUnidadMantenimientoOraltek: String(alergoideAux.oraltek.mantenimiento.caducidadUnidad), aplicacionesDataMantenimientoOraltek: (typeof alergoideAux.oraltek.mantenimiento.aplicacionesData !== 'undefined') ? alergoideAux.oraltek.mantenimiento.aplicacionesData : [{id: moment().unix(), dosis: '', repeticiones: ''}] });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, setMultipleFormFieldValidation } = useFormValidation([{field: 'alxoid', default: true}, {field: 'sitioAplicacionAlxoid', default: true}, {field: 'ladoAplicacionAlxoid', default: true}, {field: 'reaccionAlxoid', default: true}, {field: 'sitioAplicacionBrazoAlxoid', default: true}, {field: 'sitioAplicacionAbdomenAlxoid', default: true}, {field: 'sitioAplicacionOtroAlxoid', default: true}, {field: 'ladoAplicacionDerechoAlxoid', default: true}, {field: 'ladoAplicacionIzquierdoAlxoid', default: true}, {field: 'alergenoDermasAlxoid', default: true}, {field: 'alergenoDermasBlomiaAlxoid', default: true}, {field: 'alergenoPhleumPratenseAlxoid', default: true}, {field: 'alergenoLoliumAlxoid', default: true}, {field: 'alergenoCynodonAlxoid', default: true}, {field: 'alergeno6GramineasAlxoid', default: true}, {field: 'alergeno6GramineasCynodonAlxoid', default: true}, {field: 'alergeno4CerealesAlxoid', default: true}, {field: 'alergenoChenopodiumSalsolaAlxoid', default: true}, {field: 'alergenoAmbrosiaArtemisaAlxoid', default: true}, {field: 'alergenoFraxinusExcelsiorAlxoid', default: true}, {field: 'alergenoQuercusRoburAlxoid', default: true}, {field: 'alergenoCupressusAlxoid', default: true}, {field: 'alergenoPerroAlxoid', default: true}, {field: 'alergenoGatoAlxoid', default: true}, {field: 'alergenoDermas6GramineasAlxoid', default: true}, {field: 'alergenoDermas6GramineasCynodonAlxoid', default: true}, {field: 'alergenoDermas6GramineasFraxinusAlxoid', default: true}, {field: 'alergenoDermasFraxinusQuercusAlxoid', default: true}, {field: 'alergeno6GramineasCynodonQuercusFraxinusAlxoid', default: true}, {field: 'induccionAlxoid', default: true}, {field: 'frascosInduccionAlxoid', default: true}, {field: 'frecuenciaInduccionAlxoid', default: true}, {field: 'diasFrecuenciaInduccionAlxoid', default: true}, {field: 'diasSemanaInduccionAlxoid', default: true}, {field: 'rangoMinimoInduccionAlxoid', default: true}, {field: 'rangoMinimoUnidadInduccionAlxoid', default: true}, {field: 'rangoMaximoInduccionAlxoid', default: true}, {field: 'rangoMaximoUnidadInduccionAlxoid', default: true}, {field: 'caducidadInduccionAlxoid', default: true}, {field: 'caducidadUnidadInduccionAlxoid', default: true}, {field: 'aplicacionesDataInduccionAlxoid', default: true}, {field: 'mantenimientoAlxoid', default: true}, {field: 'frascosMantenimientoAlxoid', default: true}, {field: 'frecuenciaMantenimientoAlxoid', default: true}, {field: 'diasFrecuenciaMantenimientoAlxoid', default: true}, {field: 'diasSemanaMantenimientoAlxoid', default: true}, {field: 'rangoMinimoMantenimientoAlxoid', default: true}, {field: 'rangoMinimoUnidadMantenimientoAlxoid', default: true}, {field: 'rangoMaximoMantenimientoAlxoid', default: true}, {field: 'rangoMaximoUnidadMantenimientoAlxoid', default: true}, {field: 'caducidadMantenimientoAlxoid', default: true}, {field: 'caducidadUnidadMantenimientoAlxoid', default: true}, {field: 'aplicacionesDataMantenimientoAlxoid', default: true}, {field: 'oraltek', default: true}, {field: 'reaccionOraltek', default: true}, {field: 'alergenoDermasOraltek', default: true}, {field: 'alergenoCynodonOraltek', default: true}, {field: 'alergeno6GramineasOraltek', default: true}, {field: 'alergeno6GramineasCynodonOraltek', default: true}, {field: 'alergenoChenopodiumSalsolaOraltek', default: true}, {field: 'alergenoAmbrosiaArtemisaOraltek', default: true}, {field: 'alergenoFraxinusExcelsiorOraltek', default: true}, {field: 'alergenoQuercusRoburOraltek', default: true}, {field: 'alergenoCupresaceasOraltek', default: true}, {field: 'alergenoProsopisOraltek', default: true}, {field: 'alergenoDermas6GramineasOraltek', default: true}, {field: 'mantenimientoOraltek', default: true}, {field: 'frascosMantenimientoOraltek', default: true}, {field: 'frecuenciaMantenimientoOraltek', default: true}, {field: 'diasFrecuenciaMantenimientoOraltek', default: true}, {field: 'diasSemanaMantenimientoOraltek', default: true}, {field: 'rangoMinimoMantenimientoOraltek', default: true}, {field: 'rangoMinimoUnidadMantenimientoOraltek', default: true}, {field: 'rangoMaximoMantenimientoOraltek', default: true}, {field: 'rangoMaximoUnidadMantenimientoOraltek', default: true}, {field: 'caducidadMantenimientoOraltek', default: true}, {field: 'caducidadUnidadMantenimientoOraltek', default: true}, {field: 'aplicacionesDataMantenimientoOraltek', default: true}]);

    const handleChange = (e) => {
        setDataStatus(true);
        onInputChange(e);
    }

    const handleResetFields = () => {
        setTimeout(() => {
            setResetFields(true);
        }, 1);
    }

    const handleCancelChange = () => {
        onResetForm();
        setResetFields(false);
        handleResetFields();
        setTimeout(() => {
            setDataStatus(false);
        }, 1000);
    }

    const handleResetRangoMinimoUnidadMantenimientoOraltek = () => {
        setRangoMinimoUnidadMantenimientoOraltekReset(false);
        setTimeout(() => {
            setRangoMinimoUnidadMantenimientoOraltekReset(true);
        }, 1);
    }

    useEffect(() => {
        onMultipleInputChange([{ target: { name: 'rangoMinimoMantenimientoOraltek', value: 1 } }, { target: { name: 'rangoMinimoUnidadMantenimientoOraltek', value: '1' } }]);
        setMultipleFormFieldValidation([{ name: 'rangoMinimoMantenimientoOraltek', value: true }, { name: 'rangoMinimoUnidadMantenimientoOraltek', value: true }]);
        handleResetRangoMinimoUnidadMantenimientoOraltek();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frecuenciaMantenimientoOraltek])

    useEffect(() => {
        setTimeout(() => {
            setDataStatus(false);
        }, 1000);
    }, []);

    const onSubmit = async ( event ) => {
        event.preventDefault();
        
        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updateAlergoide({ data: { alxoid: { alxoid, sitioAplicacion: sitioAplicacionAlxoid, ladoAplicacion: ladoAplicacionAlxoid, reaccion: reaccionAlxoid, sitioAplicacionBrazo: sitioAplicacionBrazoAlxoid, sitioAplicacionAbdomen: sitioAplicacionAbdomenAlxoid, sitioAplicacionOtro: sitioAplicacionOtroAlxoid, ladoAplicacionDerecho: ladoAplicacionDerechoAlxoid, ladoAplicacionIzquierdo: ladoAplicacionIzquierdoAlxoid, alergenoDermas: alergenoDermasAlxoid, alergenoDermasBlomia: alergenoDermasBlomiaAlxoid, alergenoPhleumPratense: alergenoPhleumPratenseAlxoid, alergenoLolium: alergenoLoliumAlxoid, alergenoCynodon: alergenoCynodonAlxoid, alergeno6Gramineas: alergeno6GramineasAlxoid, alergeno6GramineasCynodon: alergeno6GramineasCynodonAlxoid, alergeno4Cereales: alergeno4CerealesAlxoid, alergenoChenopodiumSalsola: alergenoChenopodiumSalsolaAlxoid, alergenoAmbrosiaArtemisa: alergenoAmbrosiaArtemisaAlxoid, alergenoFraxinusExcelsior: alergenoFraxinusExcelsiorAlxoid, alergenoQuercusRobur: alergenoQuercusRoburAlxoid, alergenoCupressus: alergenoCupressusAlxoid, alergenoPerro: alergenoPerroAlxoid, alergenoGato: alergenoGatoAlxoid, alergenoDermas6Gramineas: alergenoDermas6GramineasAlxoid, alergenoDermas6GramineasCynodon: alergenoDermas6GramineasCynodonAlxoid, alergenoDermas6GramineasFraxinus: alergenoDermas6GramineasFraxinusAlxoid, alergenoDermasFraxinusQuercus: alergenoDermasFraxinusQuercusAlxoid, alergeno6GramineasCynodonQuercusFraxinus: alergeno6GramineasCynodonQuercusFraxinusAlxoid, induccion: { isActive: induccionAlxoid, frascos: frascosInduccionAlxoid, frecuencia: frecuenciaInduccionAlxoid, diasFrecuencia: diasFrecuenciaInduccionAlxoid, diasSemana: diasSemanaInduccionAlxoid, rangoMinimo: rangoMinimoInduccionAlxoid, rangoMinimoUnidad: rangoMinimoUnidadInduccionAlxoid, rangoMaximo: rangoMaximoInduccionAlxoid, rangoMaximoUnidad: rangoMaximoUnidadInduccionAlxoid, caducidad: caducidadInduccionAlxoid, caducidadUnidad: caducidadUnidadInduccionAlxoid, aplicacionesData: aplicacionesDataInduccionAlxoid }, mantenimiento: { isActive: mantenimientoAlxoid, frascos: frascosMantenimientoAlxoid, frecuencia: frecuenciaMantenimientoAlxoid, diasFrecuencia: diasFrecuenciaMantenimientoAlxoid, diasSemana: diasSemanaMantenimientoAlxoid, rangoMinimo: rangoMinimoMantenimientoAlxoid, rangoMinimoUnidad: rangoMinimoUnidadMantenimientoAlxoid, rangoMaximo: rangoMaximoMantenimientoAlxoid, rangoMaximoUnidad: rangoMaximoUnidadMantenimientoAlxoid, caducidad: caducidadMantenimientoAlxoid, caducidadUnidad: caducidadUnidadMantenimientoAlxoid, aplicacionesData: aplicacionesDataMantenimientoAlxoid } }, oraltek: { oraltek, reaccion: reaccionOraltek, alergenoDermas: alergenoDermasOraltek, alergenoCynodon: alergenoCynodonOraltek, alergeno6Gramineas: alergeno6GramineasOraltek, alergeno6GramineasCynodon: alergeno6GramineasCynodonOraltek, alergenoChenopodiumSalsola: alergenoChenopodiumSalsolaOraltek, alergenoAmbrosiaArtemisa: alergenoAmbrosiaArtemisaOraltek, alergenoFraxinusExcelsior: alergenoFraxinusExcelsiorOraltek, alergenoQuercusRobur: alergenoQuercusRoburOraltek, alergenoCupresaceas: alergenoCupresaceasOraltek, alergenoProsopis: alergenoProsopisOraltek, alergenoDermas6Gramineas: alergenoDermas6GramineasOraltek, mantenimiento: { isActive: oraltek, frascos: frascosMantenimientoOraltek, frecuencia: frecuenciaMantenimientoOraltek, diasFrecuencia: diasFrecuenciaMantenimientoOraltek, diasSemana: diasSemanaMantenimientoOraltek, rangoMinimo: rangoMinimoMantenimientoOraltek, rangoMinimoUnidad: rangoMinimoUnidadMantenimientoOraltek, rangoMaximo: rangoMaximoMantenimientoOraltek, rangoMaximoUnidad: rangoMaximoUnidadMantenimientoOraltek, caducidad: caducidadMantenimientoOraltek, caducidadUnidad: caducidadUnidadMantenimientoOraltek, aplicacionesData: aplicacionesDataMantenimientoOraltek } } } });
            setDataStatus(false);
        }else{
          startFormValidation();
        }
    
    }

    return (
        <>
            <form onSubmit={onSubmit}>
                <div className={styles.panel}>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.subHeader}>Alxoid (alergoide subcutánea)</div>
                        </div>
                        <div className="col">
                            <div className="float-end">
                                <SwitchInput
                                    checked={ (alxoid === 'true' || alxoid === true) ? true : false }
                                    label=''
                                    labelPosition='end'
                                    name='alxoid'
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    { (String(alxoid) === 'true') &&
                    <div className="row mb-2">
                        <div className="col">
                            <CheckboxInput
                                label="Sitio de aplicación"
                                name="sitioAplicacionAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (sitioAplicacionAlxoid === 'true' || sitioAplicacionAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">

                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Lado de aplicación"
                                name="ladoAplicacionAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (ladoAplicacionAlxoid === 'true' || ladoAplicacionAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Reacción"
                                name="reaccionAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (reaccionAlxoid === 'true' || reaccionAlxoid === true) ? true : false }
                            />
                        </div>
                    </div>
                    }
                    { (String(alxoid) === 'true') &&
                    <div className="row mb-3">
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Brazo"
                                    name="sitioAplicacionBrazoAlxoid"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioAplicacionBrazoAlxoid === 'true' || sitioAplicacionBrazoAlxoid === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Abdomen"
                                    name="sitioAplicacionAbdomenAlxoid"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioAplicacionAbdomenAlxoid === 'true' || sitioAplicacionAbdomenAlxoid === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Otro"
                                    name="sitioAplicacionOtroAlxoid"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioAplicacionOtroAlxoid === 'true' || sitioAplicacionOtroAlxoid === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Derecho"
                                    name="ladoAplicacionDerechoAlxoid"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (ladoAplicacionDerechoAlxoid === 'true' || ladoAplicacionDerechoAlxoid === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Izquierdo"
                                    name="ladoAplicacionIzquierdoAlxoid"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (ladoAplicacionIzquierdoAlxoid === 'true' || ladoAplicacionIzquierdoAlxoid === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                
                            </div>
                        </div>
                    </div>
                    }
                    { (String(alxoid) === 'true') &&
                    <div className="row mb-3">
                        <div className="col">
                            Alérgenos
                        </div>
                    </div>
                    }
                    { (String(alxoid) === 'true') &&
                    <div className="row mb-3">
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas"
                                name="alergenoDermasAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermasAlxoid === 'true' || alergenoDermasAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas + Blomia"
                                name="alergenoDermasBlomiaAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermasBlomiaAlxoid === 'true' || alergenoDermasBlomiaAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Phleum pratense"
                                name="alergenoPhleumPratenseAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoPhleumPratenseAlxoid === 'true' || alergenoPhleumPratenseAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Lolium"
                                name="alergenoLoliumAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoLoliumAlxoid === 'true' || alergenoLoliumAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Cynodon"
                                name="alergenoCynodonAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoCynodonAlxoid === 'true' || alergenoCynodonAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="6 Gramíneas"
                                name="alergeno6GramineasAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergeno6GramineasAlxoid === 'true' || alergeno6GramineasAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="6 Gramíneas + Cynodon"
                                name="alergeno6GramineasCynodonAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergeno6GramineasCynodonAlxoid === 'true' || alergeno6GramineasCynodonAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="4 Cereales"
                                name="alergeno4CerealesAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergeno4CerealesAlxoid === 'true' || alergeno4CerealesAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Chenopodium / Salsola"
                                name="alergenoChenopodiumSalsolaAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoChenopodiumSalsolaAlxoid === 'true' || alergenoChenopodiumSalsolaAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Ambrosia / Artemisa"
                                name="alergenoAmbrosiaArtemisaAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoAmbrosiaArtemisaAlxoid === 'true' || alergenoAmbrosiaArtemisaAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Fraxinus excelsior"
                                name="alergenoFraxinusExcelsiorAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoFraxinusExcelsiorAlxoid === 'true' || alergenoFraxinusExcelsiorAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Quercus robur"
                                name="alergenoQuercusRoburAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoQuercusRoburAlxoid === 'true' || alergenoQuercusRoburAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Cupressus"
                                name="alergenoCupressusAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoCupressusAlxoid === 'true' || alergenoCupressusAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Perro"
                                name="alergenoPerroAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoPerroAlxoid === 'true' || alergenoPerroAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Gato"
                                name="alergenoGatoAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoGatoAlxoid === 'true' || alergenoGatoAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas + 6 Gramíneas"
                                name="alergenoDermas6GramineasAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermas6GramineasAlxoid === 'true' || alergenoDermas6GramineasAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas + 6 Gramíneas + Cynodon"
                                name="alergenoDermas6GramineasCynodonAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermas6GramineasCynodonAlxoid === 'true' || alergenoDermas6GramineasCynodonAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas + 6 Gramíneas + Fraxinus"
                                name="alergenoDermas6GramineasFraxinusAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermas6GramineasFraxinusAlxoid === 'true' || alergenoDermas6GramineasFraxinusAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas + Fraxinus + Quercus"
                                name="alergenoDermasFraxinusQuercusAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermasFraxinusQuercusAlxoid === 'true' || alergenoDermasFraxinusQuercusAlxoid === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="6 Gramíneas + Cynodon + Quercus + Fraxinus"
                                name="alergeno6GramineasCynodonQuercusFraxinusAlxoid"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergeno6GramineasCynodonQuercusFraxinusAlxoid === 'true' || alergeno6GramineasCynodonQuercusFraxinusAlxoid === true) ? true : false }
                            />
                        </div>
                    </div>
                    }
                    { (String(alxoid) === 'true') &&
                    <div className={styles.panel}>
                        <div className="row mb-2">
                            <div className="col">
                                <div className={styles.subHeader}>Inducción</div>
                            </div>
                            <div className="col">
                                <div className="float-end">
                                    <SwitchInput
                                        checked={ (induccionAlxoid === 'true' || induccionAlxoid === true) ? true : false }
                                        label=''
                                        labelPosition='end'
                                        name='induccionAlxoid'
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        { (String(induccionAlxoid) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Frasco de inmunoterapia</div>
                            </div>
                        </div>
                        }
                        { (String(induccionAlxoid) === 'true') &&
                        <div className="row mb-2">
                            <div className="col">
                                {(resetFields) && 
                                <MultiFormFrascosAlxoid
                                    formsStatus={ formFields['frascosInduccionAlxoid'].status }
                                    name="frascosInduccionAlxoid"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={frascosInduccionAlxoid}
                                />
                                }
                            </div>
                        </div>
                        }
                        { (String(induccionAlxoid) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Configuración de aplicaciones</div>
                            </div>
                        </div>
                        }
                        { (String(induccionAlxoid) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-6">
                                <RadiobuttonGroup
                                    formFieldStatus={ formFields['frecuenciaInduccionAlxoid'].status }
                                    label="Frecuencia"
                                    name="frecuenciaInduccionAlxoid"
                                    onChange={ handleChange }
                                    required={ true }
                                    requiredIndicator={ false }
                                    setFormFieldValidation={ setFormFieldValidation }
                                    value={ frecuenciaInduccionAlxoid }
                                    values={ [{ label: 'Semanal', key: '2' }, { label: 'Quincenal', key: '3' }, { label: 'Mensual', key: '4' }] }
                                />
                            </div>
                        </div>
                        }
                        { (String(induccionAlxoid) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMinimoInduccionAlxoid'].status }
                                                label="Rango mínimo"
                                                min={1}
                                                name="rangoMinimoInduccionAlxoid"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMinimoInduccionAlxoid }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMinimoUnidadInduccionAlxoid'].status }
                                                label=""
                                                name="rangoMinimoUnidadInduccionAlxoid"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMinimoUnidadInduccionAlxoid}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMaximoInduccionAlxoid'].status }
                                                label="Rango máximo"
                                                min={1}
                                                name="rangoMaximoInduccionAlxoid"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMaximoInduccionAlxoid }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMaximoUnidadInduccionAlxoid'].status }
                                                label=""
                                                name="rangoMaximoUnidadInduccionAlxoid"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMaximoUnidadInduccionAlxoid}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['caducidadInduccionAlxoid'].status }
                                                label="Caducidad"
                                                min={1}
                                                name="caducidadInduccionAlxoid"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ caducidadInduccionAlxoid }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['caducidadUnidadInduccionAlxoid'].status }
                                                label=""
                                                name="caducidadUnidadInduccionAlxoid"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={caducidadUnidadInduccionAlxoid}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        { (String(induccionAlxoid) === 'true') &&
                        <div className="row">
                            <div className="col">
                                {(resetFields) &&
                                <MultiFormAplicacionML
                                    formsStatus={ formFields['aplicacionesDataInduccionAlxoid'].status }
                                    name="aplicacionesDataInduccionAlxoid"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={aplicacionesDataInduccionAlxoid}
                                />
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                    { (String(alxoid) === 'true') &&
                    <div className={styles.panel}>
                        <div className="row mb-2">
                            <div className="col">
                                <div className={styles.subHeader}>Mantenimiento</div>
                            </div>
                            <div className="col">
                                <div className="float-end">
                                    <SwitchInput
                                        checked={ (mantenimientoAlxoid === 'true' || mantenimientoAlxoid === true) ? true : false }
                                        label=''
                                        labelPosition='end'
                                        name='mantenimientoAlxoid'
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        { (String(mantenimientoAlxoid) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Frasco de inmunoterapia</div>
                            </div>
                        </div>
                        }
                        { (String(mantenimientoAlxoid) === 'true') &&
                        <div className="row mb-2">
                            <div className="col">
                                {(resetFields) && 
                                <MultiFormFrascosAlxoid
                                    formsStatus={ formFields['frascosMantenimientoAlxoid'].status }
                                    name="frascosMantenimientoAlxoid"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={frascosMantenimientoAlxoid}
                                />
                                }
                            </div>
                        </div>
                        }
                        { (String(mantenimientoAlxoid) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Configuración de aplicaciones</div>
                            </div>
                        </div>
                        }
                        { (String(mantenimientoAlxoid) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-6">
                                <RadiobuttonGroup
                                    formFieldStatus={ formFields['frecuenciaMantenimientoAlxoid'].status }
                                    label="Frecuencia"
                                    name="frecuenciaMantenimientoAlxoid"
                                    onChange={ handleChange }
                                    required={ true }
                                    requiredIndicator={ false }
                                    setFormFieldValidation={ setFormFieldValidation }
                                    value={ frecuenciaMantenimientoAlxoid }
                                    values={ [{ label: 'Semanal', key: '2' }, { label: 'Quincenal', key: '3' }, { label: 'Mensual', key: '4' }] }
                                />
                            </div>
                        </div>
                        }
                        { (String(mantenimientoAlxoid) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMinimoMantenimientoAlxoid'].status }
                                                label="Rango mínimo"
                                                min={1}
                                                name="rangoMinimoMantenimientoAlxoid"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMinimoMantenimientoAlxoid }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMinimoUnidadMantenimientoAlxoid'].status }
                                                label=""
                                                name="rangoMinimoUnidadMantenimientoAlxoid"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMinimoUnidadMantenimientoAlxoid}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMaximoMantenimientoAlxoid'].status }
                                                label="Rango máximo"
                                                min={1}
                                                name="rangoMaximoMantenimientoAlxoid"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMaximoMantenimientoAlxoid }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMaximoUnidadMantenimientoAlxoid'].status }
                                                label=""
                                                name="rangoMaximoUnidadMantenimientoAlxoid"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMaximoUnidadMantenimientoAlxoid}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['caducidadMantenimientoAlxoid'].status }
                                                label="Caducidad"
                                                min={1}
                                                name="caducidadMantenimientoAlxoid"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ caducidadMantenimientoAlxoid }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['caducidadUnidadMantenimientoAlxoid'].status }
                                                label=""
                                                name="caducidadUnidadMantenimientoAlxoid"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={caducidadUnidadMantenimientoAlxoid}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        { (String(mantenimientoAlxoid) === 'true') &&
                        <div className="row">
                            <div className="col">
                                {(resetFields) &&
                                <MultiFormAplicacionML
                                    formsStatus={ formFields['aplicacionesDataMantenimientoAlxoid'].status }
                                    name="aplicacionesDataMantenimientoAlxoid"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={aplicacionesDataMantenimientoAlxoid}
                                />
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                <div className={styles.panel}>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.subHeader}>Oraltek (alergoide sublingual)</div>
                        </div>
                        <div className="col">
                            <div className="float-end">
                                <SwitchInput
                                    checked={ (oraltek === 'true' || oraltek === true) ? true : false }
                                    label=''
                                    labelPosition='end'
                                    name='oraltek'
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    { (String(alxoid) === 'true') &&
                    <div className="row mb-2">
                        <div className="col">
                            <CheckboxInput
                                label="Reacción"
                                name="reaccionOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (reaccionOraltek === 'true' || reaccionOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">

                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">
                            
                        </div>
                    </div>
                    }
                    { (String(oraltek) === 'true') &&
                    <div className="row mb-3">
                        <div className="col">
                            Alérgenos
                        </div>
                    </div>
                    }
                    { (String(oraltek) === 'true') &&
                    <div className="row mb-3">
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas"
                                name="alergenoDermasOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermasOraltek === 'true' || alergenoDermasOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Cynodon"
                                name="alergenoCynodonOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoCynodonOraltek === 'true' || alergenoCynodonOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="6 Gramíneas"
                                name="alergeno6GramineasOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergeno6GramineasOraltek === 'true' || alergeno6GramineasOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="6 Gramíneas + Cynodon"
                                name="alergeno6GramineasCynodonOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergeno6GramineasCynodonOraltek === 'true' || alergeno6GramineasCynodonOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Chenopodium / Salsola"
                                name="alergenoChenopodiumSalsolaOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoChenopodiumSalsolaOraltek === 'true' || alergenoChenopodiumSalsolaOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Ambrosia / Artemisa"
                                name="alergenoAmbrosiaArtemisaOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoAmbrosiaArtemisaOraltek === 'true' || alergenoAmbrosiaArtemisaOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Fraxinus excelsior"
                                name="alergenoFraxinusExcelsiorOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoFraxinusExcelsiorOraltek === 'true' || alergenoFraxinusExcelsiorOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Quercus robur"
                                name="alergenoQuercusRoburOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoQuercusRoburOraltek === 'true' || alergenoQuercusRoburOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Cupresaceas"
                                name="alergenoCupresaceasOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoCupresaceasOraltek === 'true' || alergenoCupresaceasOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Prosopis"
                                name="alergenoProsopisOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoProsopisOraltek === 'true' || alergenoProsopisOraltek === true) ? true : false }
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <CheckboxInput
                                label="Dermas + 6 Gramíneas"
                                name="alergenoDermas6GramineasOraltek"
                                onChange={ handleChange }
                                required={false}
                                checked={ (alergenoDermas6GramineasOraltek === 'true' || alergenoDermas6GramineasOraltek === true) ? true : false }
                            />
                        </div>
                    </div>
                    }
                    { (String(oraltek) === 'true') &&
                    <div className={styles.panel}>
                        <div className="row mb-2">
                            <div className="col">
                                <div className={styles.subHeader}>Mantenimiento</div>
                            </div>
                        </div>
                        { (String(mantenimientoOraltek) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Frascos de inmunoterapia</div>
                            </div>
                        </div>
                        }
                        { (String(mantenimientoOraltek) === 'true') &&
                        <div className="row mb-2">
                            <div className="col">
                                {(resetFields) && 
                                <MultiFormFrascosOraltek
                                    formsStatus={ formFields['frascosMantenimientoOraltek'].status }
                                    name="frascosMantenimientoOraltek"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={frascosMantenimientoOraltek}
                                />
                                }
                            </div>
                        </div>
                        }
                        { (String(mantenimientoOraltek) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Configuración de aplicaciones</div>
                            </div>
                        </div>
                        }
                        { (String(mantenimientoOraltek) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-6">
                                <RadiobuttonGroup
                                    formFieldStatus={ formFields['frecuenciaMantenimientoOraltek'].status }
                                    label="Frecuencia"
                                    name="frecuenciaMantenimientoOraltek"
                                    onChange={ handleChange }
                                    required={ true }
                                    requiredIndicator={ false }
                                    setFormFieldValidation={ setFormFieldValidation }
                                    value={ frecuenciaMantenimientoOraltek }
                                    values={ [{ label: 'Diaria', key: '1' }, { label: 'Semanal', key: '2' }, { label: 'No. de días', key: '5' }, { label: 'Dias de la semana', key: '6' }] }
                                />
                            </div>
                            <div className="col-lg-12 col-xl-6">
                                {(frecuenciaMantenimientoOraltek === '5') &&
                                    <NumberInput
                                        formFieldStatus={ formFields['diasFrecuenciaMantenimientoOraltek'].status }
                                        label="Días de periodo"
                                        min={1}
                                        name="diasFrecuenciaMantenimientoOraltek"
                                        onChange={ handleChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ diasFrecuenciaMantenimientoOraltek }
                                    />
                                }
                                {(frecuenciaMantenimientoOraltek === '6') &&
                                    <DiasSemanaSelector
                                        formFieldStatus={ formFields['diasSemanaMantenimientoOraltek'].status }
                                        label="Selección de días"
                                        name="diasSemanaMantenimientoOraltek"
                                        onChange={ handleChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ diasSemanaMantenimientoOraltek }
                                    />
                                }
                            </div>
                        </div>
                        }
                        { (String(mantenimientoOraltek) === 'true') &&
                        <div className="row mb-2">
                            {(frecuenciaMantenimientoOraltek !== '1') &&
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMinimoMantenimientoOraltek'].status }
                                                label="Rango mínimo"
                                                min={1}
                                                name="rangoMinimoMantenimientoOraltek"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMinimoMantenimientoOraltek }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields && rangoMinimoUnidadMantenimientoOraltekReset) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMinimoUnidadMantenimientoOraltek'].status }
                                                label=""
                                                name="rangoMinimoUnidadMantenimientoOraltek"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMinimoUnidadMantenimientoOraltek}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            <div className={(frecuenciaMantenimientoOraltek !== '1') ? 'col-lg-12 col-xl-4' : 'co-lg-12 col-xl-6' }>
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMaximoMantenimientoOraltek'].status }
                                                label="Rango máximo"
                                                min={1}
                                                name="rangoMaximoMantenimientoOraltek"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMaximoMantenimientoOraltek }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMaximoUnidadMantenimientoOraltek'].status }
                                                label=""
                                                name="rangoMaximoUnidadMantenimientoOraltek"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMaximoUnidadMantenimientoOraltek}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={(frecuenciaMantenimientoOraltek !== '1') ? 'col-lg-12 col-xl-4' : 'co-lg-12 col-xl-6' }>
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['caducidadMantenimientoOraltek'].status }
                                                label="Caducidad"
                                                min={1}
                                                name="caducidadMantenimientoOraltek"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ caducidadMantenimientoOraltek }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['caducidadUnidadMantenimientoOraltek'].status }
                                                label=""
                                                name="caducidadUnidadMantenimientoOraltek"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={caducidadUnidadMantenimientoOraltek}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        { (String(mantenimientoOraltek) === 'true') &&
                        <div className="row">
                            <div className="col">
                                {(resetFields) &&
                                <MultiFormAplicacionGotas
                                    formsStatus={ formFields['aplicacionesDataMantenimientoOraltek'].status }
                                    name="aplicacionesDataMantenimientoOraltek"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={aplicacionesDataMantenimientoOraltek}
                                />
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                <div className="row mb-3">
                    <div className="col-sm-12 col-md">
                        <div className='d-flex justify-content-end'>
                            <LightButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="X"
                                marginTop={false}
                                marginRight={true}
                                onClick={handleCancelChange}
                                text="Cancelar"
                                type="button"
                            />
                            <PrimaryButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="Check"
                                marginTop={false}
                                text="Guardar"
                                type="submit"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

AlergoideUpdate.propTypes = {
    alergoideAux: PropTypes.object.isRequired,
}